import React from 'react';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import './styles.css';

const VacationPanel: React.FC = () => (
  <Container maxWidth="lg" sx={{ marginTop: 10, marginBottom: 0 }}>
    <Grid container spacing={6}>
      <Grid item sm={12} md={6} className="info_tile">
        <Typography variant="h5" color="text.secondary">
          Professional travel & leisure solutions provider with sense of homely
          nature.
          <br />
          <br />
          We always aiming at keeping you delighted by providing travel &
          leisure solutions to match your wallet with warrantied value delivery.
        </Typography>
      </Grid>
      <Grid item sm={12} md={6}>
        <img
          alt="guaranteed quality service"
          src="/images/vacation.webp"
          className="vacation"
        />
      </Grid>
    </Grid>
  </Container>
);

export default VacationPanel;
